import { render, staticRenderFns } from "./Radios.vue?vue&type=template&id=1f628e13&"
import script from "./Radios.vue?vue&type=script&lang=js&"
export * from "./Radios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports